export interface INewContactValidation {
    firstName: boolean,
    lastName: boolean,
    email: boolean,
    phoneNumber: boolean
}